import { flowRight } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import InputToggle from '../input-toggle';
import { HorizontalSeparator } from '../separator';
import withCardBorderWidth from '../../hoc/with-card-border-width';
import withDeviceType from '../../hoc/with-device-type';
import withFontClassName from '../../hoc/with-font-class-name';
import withTranslate from '../../hoc/with-translate';
import styles from './notifications-settings.scss';

const NotificationsSettings = ({
  settings = [],
  onChange,
  isChecked,
  t,
  borderWidth,
  titleFontClassName,
  contentFontClassName,
  isMobile,
}) => {
  const className = classNames(
    styles.container,
    contentFontClassName,
    'forum-card-background-color',
    'forum-card-border-color',
    'forum-text-color'
  );
  return (
    <div className={className} style={{ borderWidth }}>
      <table className={styles.table}>
        <thead>
          <tr>
            <td className={styles.tdTitle}>
              {isMobile ? t('notifications-settings.notifications') : null}
            </td>
            <td className={styles.tdTitle}>
              {t(isMobile ? 'notifications-settings.email' : 'notifications-settings.email-notifications')}
            </td>
          </tr>
          <tr>
            <td colSpan="2">
              <HorizontalSeparator/>
            </td>
          </tr>
        </thead>

        <tbody>
          {settings.map(key => {
            return [
              <tr key={key} className={styles.tr}>
                <td className={styles.tdInformation}>
                  <div className={titleFontClassName}>
                    <h3 className={styles.title}>
                      {t(`notifications-settings.${key}`)}
                    </h3>
                  </div>
                  <p className={styles.description}>
                    {t(`notifications-settings.${key}-description`)}
                  </p>
                </td>
                <td className={styles.tdToggle}>
                  <InputToggle checked={isChecked('email', key)} onChange={onChange('email', key)}/>
                </td>
              </tr>,
              <tr key={`${key}-separator`} className={styles.tr}>
                <td colSpan="2">
                  <HorizontalSeparator/>
                </td>
              </tr>,
            ];
          })}
        </tbody>
      </table>
    </div>
  );
};

NotificationsSettings.propTypes = {
  settings: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  isChecked: PropTypes.func.isRequired,
  borderWidth: PropTypes.number,
  titleFontClassName: PropTypes.string,
  contentFontClassName: PropTypes.string,
  t: PropTypes.func,
  isMobile: PropTypes.bool,
};

export default flowRight(
  withCardBorderWidth,
  withDeviceType,
  withFontClassName,
  withTranslate
)(NotificationsSettings);



// WEBPACK FOOTER //
// ./app/components/notifications-settings/notifications-settings.js